import { units } from "./units";
const {u_001, u_002, u_003, u_004, u_005, u_006, u_007, u_008, u_009, u_010, u_011, u_012, u_013, u_014, u_015, u_016} = units
export const organisers = {
  "os_001": {
    "uo_001": {
      title: "Course Curriculum",
      description: "Which are the units to be covered in each semester and what is the delivery approach for every unit? Find in this section.",
      units: {u_001},
      route: "/",
    },
    "uo_002": {
      title: "Student Assessment Framework",
      description: "Guidelines for how students could be assessed for the course.",
      units: {u_002},
      route: "/",
    },
    "uo_003": {
      title: "Student Orientation Presentation",
      description: "You can use this at the beginning of the semester to give students visibility on what to expect.",
      units: {u_003},
      route: "/",
    },
    "uo_004": {
      title: "Audit Framework",
      description: "Find the audit framework and past audit reports in this section. Use these to track your own improvement journey as a college.",
      units: {u_004},
      route: "/",
    },
  },"os_002": {
    "uo_001": {
      title: "Facilitation Guides",
      description: "Includes facilitation best practices and unit-wise facilitator guides to help you build yourself as a facilitator of the course.",
      units: {u_005, u_006},
      route: "/",
    },
    "uo_002": {
      title: "Design Guides",
      description: "Each design exercise in the textbook is supported with design guides which can find in this section.",
      units: {u_007, u_008, u_009},
      route: "/",
    },
    "uo_003": {
      title: "Project Support",
      description: " In the textbook, there are research or field projects that students can do. These projects help them internalize some key shifts or constructs they are learning in the unit, by observing how they operate in real-life. The guides in this section will help you guide students in these projects effectively.",
      units: {},
      route: "/",
    },
    "uo_004": {
      title: "Showcase Support",
      description: "These guides will help you to effectively support your students in building their showcasable output.",
      units: {},
      route: "/",
    },
  },"os_003": {
    "uo_001": {
      title: "Unit 2: The Contributor's Identity",
      description: "Dive deeper into questions such as what is identity? How it shapes us? Why is it necessary to consciously work on our identity?, etc.",
      units: {u_014, u_015, u_016},
      route: "/",
    },
    "uo_002": {
      title: "Unit 7: Design Solutions",
      description: "How is solution thinking different from problem solving or process thinking? Why is solution thinking so crucial? Where does it get applied? Dive deep into different aspects of solution thinking.",
      units: {u_010, u_011},
      route: "/",
    },
    "uo_003": {
      title: "Unit 11: Practice Imaginative Sympathy",
      description: "",
      units: {u_012, u_013},
      route: "/",
    }
  },"os_004": {
    "uo_001": {
      title: "Audit",
      description: "Find the audit framework and past audit reports in this section. Use these to track your own improvement journey as a college.",
      units: {u_004},
      route: "/",
    },
  }
}


// WEBPACK FOOTER //
// ./src/modal/channelOrganiser.js